module.exports = __webpack_public_path__ + "static/img/3_11_25.9a94994a.png";